import { useEffect as f } from "react";
function L(o, r) {
  f(
    () => {
      let c = !1, s = 0, u = 0;
      const i = (t) => {
        !o.current || o.current.contains(t.target) || r(t);
      }, d = (t) => {
        const { touches: n } = t, e = n && n.item(0);
        e && (s = e.clientX, u = e.clientY, c = !1);
      }, m = (t) => {
        const { touches: n } = t, e = n && n.item(0);
        if (!e)
          return;
        const l = Math.abs(e.clientX - s), v = Math.abs(e.clientY - u), h = 5;
        c = l > h || v > h;
      }, a = (t) => {
        c || (i(t), s = 0, u = 0);
      };
      return document && document.addEventListener && (document.addEventListener("mousedown", i), document.addEventListener("touchstart", d, !1), document.addEventListener("touchmove", m, !1), document.addEventListener("touchend", a, !1)), () => {
        document && document.addEventListener && (document.removeEventListener("mousedown", i), document.removeEventListener("touchmove", m), document.removeEventListener("touchstart", d), document.removeEventListener("touchend", a));
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [o, r]
  );
}
export {
  L as useOnClickOutside
};
//# sourceMappingURL=useOnClickOutside.js.map
